export default __webpack_public_path__ + "static/media/A64.49b72c1f.jpg";